import { CartOverlay } from "../components/cart-overlay";

export const MarketplaceLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="container flex flex-col gap-8 w-full mx-auto h-full">
      <Header />
      <div className="flex-1 min-h-0"> 
        {children}                          
      </div>
    </div>
  );
}

const Header = () => {
  return(
    <div className="flex flex-row justify-between shrink-0">
      <div>
        <h1 className="text-3xl font-bold text-white">Marketplace</h1>
      </div>
      <div className="flex flex-col justify-center items-center gap-1">
        <CartOverlay />  
      </div>
    </div>
  );
};

export default MarketplaceLayout;
